import React, { useState } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Col, Message, Cascader, ControlLabel, Button, Row, IconButton, Icon } from 'rsuite'
import NumberFormat from 'react-number-format'
import { useForm, Controller } from 'react-hook-form'
import classNames from 'classnames'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  saveBudgetPlanAtInstallmentStepMuti,
  saveBudgetPlanMuti,
} from '../../../redux/actions/paymentSave'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import EditButton from '../../../components/buttons/editButton/EditButton'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'

export default function BudgetPlanMutiV2({
  header,
  isEditable,
  isEdit: _isEdit,
  isEditCancle,
  masterBudgetPlan: _masterBudgetPlan,
  masterBudgetValue: _masterBudgetValue,
  subBudgetPlan: _subBudgetPlan,
  subBudgetValue: _subBudgetValue,
  onComplete,
  shaded,
}) {
  const {
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    watch,
  } = useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(isEditable && _isEdit)
  const [isError, setIsError] = useState(false)
  const [masterBudgetPlan, setMasterBudgetPlan] = useState(_masterBudgetPlan)
  // const [masterBudgetValue, setMasterBudgetValue] = useState(_masterBudgetValue)
  // const [subBudgetPlan, setSubBudgetPlan] = useState(_subBudgetPlan)
  // const [subBudgetValue, setSubBudgetValue] = useState(_subBudgetValue)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleSaveBudgetPlan = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      await saveBudgetPlanMuti(request)

      if (typeof onComplete === 'function') {
        onComplete()
      }
      if (isEditCancle) {
        setIsEdit(false)
      }
    } catch (e) {
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    const request = {
      groupId: projectId,
      masterBudgetPlanValue: data.masterBudgetPlan,
    }
    // console.log('request', request)
    handleSaveBudgetPlan(request)
  }

  return (
    <Panel header={header} bordered collapsible defaultExpanded shaded={shaded}>
      {masterBudgetPlan && (
        <div>
          <Message
            showIcon
            type="warning"
            description={`การบันทึกแผนงบประมาณพร้อมกันหลายโครงการ ระบบจะใช้งบประมาณตามที่ขอของแต่ละโครงการแทน`}
          />
          <br />

          {isEdit ? (
            <Row>
              <Col style={{ marginTop: '10px' }}>
                <ControlLabel
                  style={{ fontWeight: 'bold' }}
                  className={classNames(isRequired(masterBudgetPlan?.validators) && 'required')}
                >
                  {masterBudgetPlan?.label}
                </ControlLabel>
                <ErrorMessage error={errors.masterBudgetPlan} />
                <Controller
                  name={'masterBudgetPlan'}
                  control={control}
                  defaultValue={masterBudgetPlan?.value}
                  rules={isValidators(masterBudgetPlan?.validators)}
                  render={(props) => {
                    return (
                      <Cascader
                        size="lg"
                        block
                        menuWidth={220}
                        data={masterBudgetPlan?.items}
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          setValue('subBudgetPlan', null)
                        }}
                        placeholder={masterBudgetPlan?.label}
                      ></Cascader>
                    )
                  }}
                />
              </Col>
            </Row>
          ) : (
            <>
              <p style={{ fontWeight: 'bold' }}>{masterBudgetPlan?.label}</p>
              <p>{masterBudgetPlan?.text ? masterBudgetPlan?.text : '-'}</p>
              {/* <p>{`${masterBudgetValue?.label || ''} ${(
                masterBudgetValue?.value || 0
              ).toLocaleString()} บาท`}</p> */}
            </>
          )}
        </div>
      )}

      {isEditable && (
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          style={{ marginBottom: 20, marginTop: 20, padding: 0 }}
        >
          {isEdit ? (
            <div>
              {isError && (
                <div style={{ marginBottom: 10 }}>
                  <Message
                    showIcon
                    type="error"
                    description={`เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
                  />
                </div>
              )}
              <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}>
                {'บันทึกแผนงบประมาณไปยังทุกโครงการ'}
              </SaveButton>

              {isEditCancle && (
                <Button
                  style={{ marginLeft: 20 }}
                  appearance="ghost"
                  onClick={() => {
                    //setIsSubBudgetPlan(subBudgetPlan?.value || subBudgetPlan?.value ? true : false)
                    setIsEdit(false)
                  }}
                  disabled={isLoading}
                >
                  ยกเลิกการแก้ไข
                </Button>
              )}
            </div>
          ) : (
            <EditButton
              onClick={() => {
                setIsEdit(true)
              }}
            >
              แก้ไขแผน
            </EditButton>
          )}
        </Col>
      )}
    </Panel>
  )
}
